// Mutation hook - modyfikacja kontaktu transakcji
// PUT /api/ui/sales-crm/deals/{id}/contacts/{contactId}

import { axios } from 'api';
import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';
import type { IPutDealContactRequest } from 'api/types/deals';

interface IPutDealContactResponse {
  data?: { id?: number };
  message?: string;
  status?: string;
}

interface IPutDealContactVariables {
  dealId: number;
  contactId: number;
  body: IPutDealContactRequest;
}

const putDealContact = ({
  dealId,
  contactId,
  body,
}: IPutDealContactVariables): Promise<IPutDealContactResponse> =>
  axios.put(`/sales-crm/deals/${dealId}/contacts/${contactId}`, body);

export const usePutDealContact = (
  options?: UseMutationOptions<IPutDealContactResponse, IError, IPutDealContactVariables>,
) => {
  const queryClient = useQueryClient();
  return useMutation<IPutDealContactResponse, IError, IPutDealContactVariables>(putDealContact, {
    ...options,
    onSuccess: async (data, variables, context) => {
      await queryClient.invalidateQueries(['sales-crm-deal-contacts', variables.dealId]);
      await queryClient.refetchQueries(['sales-crm-deal-contacts', variables.dealId]);
      options?.onSuccess?.(data, variables, context);
    },
  });
};
